import { Collapse, Typography } from '@material-ui/core';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { ResolverTag } from '@ps/web-core-enums';
import type { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';
import { InfoPrompt } from '@swf/first';

import BalanceRecordItem from '../BalanceRecordItem/BalanceRecordItem';

import {
  TXTCLI_In_Play,
  TXTWCL_For_more_information_about_Pla_ELL,
  TXTWCL_If_you_would_like_more_informa_ELL_1,
  TXTWCL_In_Play_Funds_1,
  TXTWCL_In_Play_funds_are_incomplete_g_ELL_2,
  TXTWCL_This_is_the_total_of_what_you__ELL,
  TXTWCL_Withdrawable
} from './BalanceRecord.messages.json';
import { collapse, container } from './BalanceRecord.scss';

interface Props {
  availableForCashout: number;
  currency: Currency;
  balanceTotal: number;
  balanceAllocated: number;
  preferred: boolean;
  multiBalances: boolean;
}

const BalanceRecord: React.FC<Props> = ({
  availableForCashout,
  currency,
  balanceTotal,
  balanceAllocated,
  preferred,
  multiBalances
}) => {
  const [expand, setExpand] = useState(!multiBalances);
  const isDE = useSelector(select.cms.getSiteId) === Sites.DE;

  return (
    <div className={container} data-testid={`item-${currency}`}>
      <div onClick={() => setExpand(!expand)}>
        <BalanceRecordItem
          balance={balanceTotal}
          currency={currency}
          isHeader
          expand={expand}
          preferred={multiBalances && preferred}
        />
      </div>
      <Collapse className={classNames(container)} in={expand}>
        <div className={collapse}>
          <BalanceRecordItem
            balance={balanceAllocated}
            currency={currency}
            label={<Translation {...TXTCLI_In_Play} />}
            info={
              <InfoPrompt title={{ translation: TXTWCL_In_Play_Funds_1 }} variant="wallet">
                <Typography>
                  <Translation {...TXTWCL_In_Play_funds_are_incomplete_g_ELL_2} />{' '}
                  <Translation
                    {...TXTWCL_If_you_would_like_more_informa_ELL_1}
                    values={{
                      a: (msg: React.ReactNode) => (
                        <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
                      )
                    }}
                  />
                </Typography>
              </InfoPrompt>
            }
          />
          <BalanceRecordItem
            balance={availableForCashout}
            currency={currency}
            label={<Translation {...TXTWCL_Withdrawable} />}
            info={
              isDE && (
                <InfoPrompt title={{ translation: TXTWCL_Withdrawable }} variant="wallet">
                  <Typography>
                    <Translation {...TXTWCL_This_is_the_total_of_what_you__ELL} />
                  </Typography>
                  <Typography>
                    <Translation
                      {...TXTWCL_For_more_information_about_Pla_ELL}
                      values={{
                        a: (msg: React.ReactNode) => (
                          <ResolverLink resolverTag={ResolverTag.DEPlayingBalanceLimit}>
                            {msg}
                          </ResolverLink>
                        )
                      }}
                    />
                  </Typography>
                </InfoPrompt>
              )
            }
          />
        </div>
      </Collapse>
    </div>
  );
};
export default BalanceRecord;
